<h1 class="title">{{'MAILERS.TITLE' | translate}}</h1>

<div class="add-btn">
    <button routerLink="/email-details/new" mat-fab aria-label="">
        <mat-icon>add</mat-icon>
    </button>
</div>

<div style="max-width: 600px; margin: 0 auto;">
<mat-card>
    <mat-card-content>
        <vzn-data-table #table [restService]="emailService" [pageSize]="25" [columns]="columns" [query]="query"
            [mapper]="emailMapper" (rowDblClick)="onDoubleClick($event)">
        </vzn-data-table>
        <!-- <ng-template #sendEmailButtonTmpl let-row="row" let-height="column.height" ngx-datatable-cell-template>
            <button (click)="sendEmail($event, row)" mat-raised-button>שלח אימייל</button>
        </ng-template> -->
    </mat-card-content>
</mat-card>
</div>

